"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogradouroBairro = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
let LogradouroBairro = class LogradouroBairro extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdLogradouroBairro = void (0);
        this.cdLogradouro = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_logradouro_bairro" }),
    __metadata("design:type", Number)
], LogradouroBairro.prototype, "cdLogradouroBairro", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_logradouro" }),
    __metadata("design:type", Number)
], LogradouroBairro.prototype, "cdLogradouro", void 0);
LogradouroBairro = __decorate([
    typeorm_1.Entity('grl_logradouro_bairro')
], LogradouroBairro);
exports.LogradouroBairro = LogradouroBairro;
